import { styled } from '@linaria/react';

const Text = styled.div`
  --ts-and-cs-font-size: 0.65em; /* 10px */

  display: flex;
  flex-direction: column;
  font-style: normal;
  font-weight: 500;
  letter-spacing: 0.005em;
  line-height: 0.75em;

  & > * {
    font-size: var(--ts-and-cs-font-size);
  }

  p {
    margin: 0;
    padding-top: 1em; /* 10px */
  }

  p:last-of-type,
  p:only-child {
    margin-bottom: 0.8em; /* 8px */
  }

  p:empty {
    display: none;
  }

  hr {
    display: none;
  }

  a,
  a:visited {
    color: var(--anchor-color);
    text-decoration: underline;
  }
`;

export default Text;
